import React from "react";

export default function RightAlignmentIcon(props) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 6.24 6.24"
      enableBackground="new 0 0 6.24 6.24"
    >
      <path
        fill={props.color}
        d="m0,.48v-0.48h6.24v0.48h-6.24zm1.439,1.92v-0.48h4.801v0.48h-4.801zm-1.439,1.92v-0.48h6.24v0.48h-6.24zm1.439,1.92v-0.479h4.801v0.479h-4.801z"
      />
    </svg>
  );
}
